export default __webpack_public_path__ + "static/media/Artboard 27.829ab312.png";